module.exports = __webpack_public_path__ + "reg-3-icon.png?cb44ae189f6367783f88e2e78e32dc66";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg-3-icon.png
// module id = 206
// module chunks = 0